function formatDate(date) {
    return date.toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}
function getDeliveryDates() {
    const today = new Date();
    const standardStart = new Date(today);
    standardStart.setDate(today.getDate() + 3);
    const standardEnd = new Date(today);
    standardEnd.setDate(today.getDate() + 7);
    const expressStart = new Date(today);
    expressStart.setDate(today.getDate() + 1);
    const expressEnd = new Date(today);
    expressEnd.setDate(today.getDate() + 3);
    return {
        standard: `${formatDate(standardStart)} - ${formatDate(standardEnd)}`,
        express: `${formatDate(expressStart)} - ${formatDate(expressEnd)}`
    };
}
const deliveryDates = getDeliveryDates();

document.addEventListener("DOMContentLoaded", () => {
    const deliveryDates = getDeliveryDates();
    document.querySelector(".standard-shipping").textContent = deliveryDates.standard;
    document.querySelector(".express-shipping").textContent = deliveryDates.express;
});
